export const hideTokenInPath = {
  parse: {
    token: (token: string) => token.replace(/^@/, ''),
  },
  stringify: { token: () => '' },
}
